// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"292":"1c8ef664584a42e09b13","928":"6fce85e882941ddff039"}[chunkId] + ".js";
};